import { CommonModule } from '@angular/common';
import { ApplicationInfo, EnvironmentService } from '@abp/ng.core';
import { Component } from '@angular/core';

@Component({
  imports: [CommonModule],
  selector: 'dw-ui-spinning-loader',
  templateUrl: './spinning-loader.component.html',
  styleUrl: './spinning-loader.component.scss',
  standalone: true,
})
export class SpinningLoaderComponent {
  get appInfo(): ApplicationInfo {
    return this.environment.getEnvironment().application;
  }

  constructor(private environment: EnvironmentService) {}
}
